<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            Alterações <strong>Realizadas</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox"> 
      <v-flex infoDados>         
        <v-card>
         <table class="v-datatable v-table theme--light">
            <thead>
              <template v-for="header in cabecalhoResumoAlteracao">
                 <th role="columnheader" scope="col" class="column text-xs-left" :width="header.width" :key="header.id">                   
                     {{header.text}}                   
                 </th>
              </template>
            </thead>
            <tbody>
              <template v-for="(alteracoes, aba) in byAba">
                <tr :key="aba">
                  <td colspan="3" style="color:gray;font-size: 12px;text-transform: uppercase;background-color:floralwhite;"><strong>{{getLabelAba(aba)}}</strong></td>
                </tr>
                <tr v-for="item in alteracoes" :key="item.id">
                  <td class="text-xs-left">{{getLabelCampo(item.propriedade)}}</td>
                  <td class="text-xs-left">{{isLink(item.oldValor) ?  "" : adcionaZeroEsquerda(item.oldValor, item.propriedade === "EndCep")}}
                    <a v-if="isLink(item.oldValor)" v-bind:href="item.oldValor" target="_blank" ><v-icon color="blue" ti>attach_file</v-icon></a>
                  </td>
                  <td class="text-xs-left">{{item.acao == "edit" && !isLink(item.newValor) ? item.newValor : ""}}
                       <div v-if="item.acao == 'add'">
                          <div v-for="(value, name) in item.newValor" v-bind:key="name">
                           <span v-show="getLabelCampo(name) != 'hide'" >
                              <b>{{ getLabelCampo(name) }}</b>: {{isLink(value) ?  "" : value}}
                              <a v-if="isLink(value)" v-bind:href="value"  target="_blank"><v-icon color="blue" ti>attach_file</v-icon></a>
                           </span>
                          </div>
                       </div>
                       <a v-if="isLink(item.newValor) && item.acao == 'edit'" v-bind:href="item.newValor" target="_blank"><v-icon color="blue" ti>attach_file</v-icon></a>
                  </td>
                </tr>
              </template>
            </tbody>
           </table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import util from "../../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "campos-alterados",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object
  },
  created() /*Metodo de start do componente*/{ },
  computed:{
    byAba(){
      return this.model.listHistorico.reduce((acc, hist) => {
        (acc[hist.entidade] = acc[hist.entidade] || []).push({"propriedade": hist.propriedade, "oldValor" : hist.oldValor,
                                                              "newValor" : hist.newValor, "acao": hist.acao, "id": hist.$id })
        return acc
      }, {})
    }
  },
  data() {//Declaracao de variaveis
    return {
      showBox: false,
    };
  },
  methods: {//Declaracao de todos os metodos
    openBox() {
      this.showBox = !this.showBox;
    },
    
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}
</style>